module.exports = __webpack_public_path__ + "static/media/23-8.e880aa5b.mp3";